import { MRT_ColumnFiltersState } from 'mantine-react-table';

import { Filters } from '@data-access';

import { ResultsSummary } from '../data-access/types/results';

export type { ResultsSummary as ResultsStats };

export function getResultsSummaryFilters(
  columnFilters: MRT_ColumnFiltersState,
): Filters {
  return {
    page: 1,
    sorting: [],
    filters: columnFilters,
  };
}

export const GES_STATUS_STAT_ORDER = [0, 1, 2, 3] as const;

export type GesStatusStat = (typeof GES_STATUS_STAT_ORDER)[number];

export function getGesStatusCount(
  summary: ResultsSummary | undefined,
  status: (typeof GES_STATUS_STAT_ORDER)[number],
): number | undefined {
  if (!summary) return undefined;
  const counts = summary.ges_status;
  return counts[String(status)] ?? counts[status] ?? 0;
}
